import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const DraftPrescriptionParaclinicalItemService = {
  getDraftPrescriptionParaclinicalItemList(params: any){ return axiosRequest('GET', API_PATH.DRAFT_PRESCRIPTION_PARACLINICAL_ITEM.LIST(params)) },
  getDraftPrescriptionParaclinicalItem(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION_PARACLINICAL_ITEM.INFO, data) },
  addDraftPrescriptionParaclinicalItem(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION_PARACLINICAL_ITEM.ADD, data) },
  deleteDraftPrescriptionParaclinicalItem(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION_PARACLINICAL_ITEM.DELETE, data) },
}